import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ArrowLeft, User, Building2, MessageSquare, LogOut, ChevronRight } from "lucide-react";

export default function MiEspacio() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const profileTo = user?.id ? `/employees/${user.id}` : "/me";

  const items = [
    { label: "Mi perfil", desc: "Consulta y edita tu perfil, avatar y proyecto asignado.", icon: User, accent: "#2563EB", onClick: () => nav(profileTo), testid: "espacio-profile" },
    { label: "Contacto oficina central", desc: "Encuentra al staff de oficina central para soporte o consultas.", icon: Building2, accent: "#16A34A", onClick: () => nav("/employees?staff_type=oficina"), testid: "espacio-contact" },
    { label: "Buzón de comentarios", desc: "Comparte ideas y sugerencias con el equipo por tema.", icon: MessageSquare, accent: "#8B5CF6", onClick: () => nav("/buzon"), testid: "espacio-feedback" },
  ];

  return (
    <div className="max-w-2xl mx-auto space-y-6" data-testid="mi-espacio-page">
      <Link to="/" className="inline-flex items-center text-xs uppercase tracking-[0.18em] text-[#5C6A7D] hover:text-[#0A2540]"><ArrowLeft size={14} className="mr-1" /> Lobby</Link>
      <div>
        <div className="text-[10px] uppercase tracking-[0.25em] text-[#F97316] font-bold">Mi espacio</div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-[#0A2540] tracking-tighter mt-1">Hola, {user?.name?.split(" ")[0]}.</h1>
      </div>
      <div className="bg-white border border-[#E2E8F0] rounded-2xl divide-y divide-[#E2E8F0] overflow-hidden">
        {items.map((it) => {
          const Inner = (
            <>
              <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0" style={{ background: `${it.accent}14`, color: it.accent }}><it.icon size={20} strokeWidth={1.75} /></div>
              <div className="flex-1 min-w-0"><div className="font-semibold text-[#0A2540]">{it.label}</div><div className="text-xs text-[#5C6A7D] mt-0.5">{it.desc}</div></div>
              <ChevronRight size={18} className="text-[#94A3B8] shrink-0" />
            </>
          );
          return it.href ? (
            <a key={it.label} href={it.href} className="flex items-center gap-4 px-5 py-4 hover:bg-[#FAFAFA] transition-colors" data-testid={it.testid}>{Inner}</a>
          ) : (
            <button key={it.label} onClick={it.onClick} className="w-full text-left flex items-center gap-4 px-5 py-4 hover:bg-[#FAFAFA] transition-colors" data-testid={it.testid}>{Inner}</button>
          );
        })}
        <button onClick={logout} className="w-full text-left flex items-center gap-4 px-5 py-4 hover:bg-[#FEF2F2] transition-colors" data-testid="espacio-logout">
          <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0 bg-[#E11D48]/10 text-[#E11D48]"><LogOut size={20} strokeWidth={1.75} /></div>
          <div className="flex-1"><div className="font-semibold text-[#E11D48]">Cerrar sesión</div><div className="text-xs text-[#5C6A7D] mt-0.5">Salir de tu cuenta de forma segura.</div></div>
          <ChevronRight size={18} className="text-[#94A3B8]" />
        </button>
      </div>
    </div>
  );
}
